import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import React from 'react'

import { Container } from '../../../../../ui'
import InventoryEnvironmentList from '../InventoryEnvironmentList'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('tablet')]: {
      flexDirection: 'row',
    },
  },
  filterPanel: {
    [theme.breakpoints.up('tablet')]: {
      marginRight: theme.spacing(2),
      width: 220,
    },
  },
  rightBox: {
    flexGrow: 1,
  },
  searchInput: {
    [theme.breakpoints.up('mobile')]: {
      marginLeft: theme.spacing(2),
    },
  },
  toolbar: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    '& > *': {
      marginBottom: theme.spacing(1),
    },
    '& > *:last-child': {
      marginBottom: 0,
    },
    [theme.breakpoints.up('mobile')]: {
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
      '& > *': {
        marginBottom: theme.spacing(0),
      },
    },
  },
}))

export const InventoryListView = ({
  fetching,
  lastPageWasSupplier,
  onFetchSuppliers,
  section,
  suppliers,
  ...props
}) => {
  const classes = useStyles()

  return (
    <Container className={classes.root}>
      <div className={classes.rightBox}>
        <div className={classes.toolbar}></div>
        <InventoryEnvironmentList />
      </div>
    </Container>
  )
}

InventoryListView.propTypes = {
  fetching: PropTypes.bool,
  lastPageWasSupplier: PropTypes.bool,
  onFetchSuppliers: PropTypes.func,
  suppliers: PropTypes.object,
}

export default InventoryListView
